import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  MoreOutlined
} from "@ant-design/icons"
import { Button, Dropdown, Flex } from "antd"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { ROLE_LABEL_STATUSES } from "../../../constants/role-labels.ts"
import { cn } from "../../../utils/cn.ts"
import type { PermissionLabel } from "../types/permissions.types.ts"

interface PermissionsLabelsItemProps {
  item: PermissionLabel
  onEdit: (item: PermissionLabel) => void
  onDelete: (id: number) => void
  onDuplicate: (item: PermissionLabel) => void
}

export function PermissionsLabelsItem({
  item,
  onEdit,
  onDelete,
  onDuplicate
}: PermissionsLabelsItemProps) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const handleMenuClick = ({ key }: { key: string }) => {
    if (key === "edit") onEdit(item)
    if (key === "delete") onDelete(item?.id)
    if (key === "duplicate") onDuplicate(item)
  }

  const isGccOwner =
    !!item?.is_system && item?.code === ROLE_LABEL_STATUSES.OWNER

  const menuItems = [
    ...(isGccOwner
      ? []
      : [{ key: "edit", icon: <EditOutlined />, label: "Rename" }]),
    { key: "duplicate", icon: <CopyOutlined />, label: "Duplicate" },
    ...(item?.is_system
      ? []
      : [
          {
            key: "delete",
            icon: <DeleteOutlined />,
            label: "Delete",
            danger: true
          }
        ])
  ]

  return (
    <Flex align="center" className="group/tab min-h-6 px-4 py-2" gap={6}>
      {item?.name}
      {item?.user_count > 0 && (
        <>
          <span className="text-xs opacity-60" aria-hidden="true">
            ({item.user_count})
          </span>
          <span className="sr-only">
            {t("permissions.roleUserCount", { count: item.user_count })}
          </span>
        </>
      )}
      {/*{!item?.is_system && (*/}
      <div
        className={cn(
          "max-w-0 overflow-hidden group-hover/tab:max-w-[32px] transition-all duration-200 ease-in-out",
          { "max-w-[32px]": open }
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <Dropdown
          open={open}
          onOpenChange={setOpen}
          menu={{
            items: menuItems,
            onClick: handleMenuClick
          }}
          trigger={["click"]}
          placement="bottomRight"
        >
          <Button variant="outlined" size="small" icon={<MoreOutlined />} />
        </Dropdown>
      </div>
      {/*)}*/}
    </Flex>
  )
}
